import React from 'react';

import { SVGPropsType } from 'src/types';

const Calculator = (props: SVGPropsType) => {
    const { stroke, fill, onClick, style, className } = props;
    return (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M10.5 2.5H16.3333C17.25 2.5 18 3.25 18 4.16667V15.8333C18 16.75 17.25 17.5 16.3333 17.5H10.5M10.5 2.5H4.66667C3.75 2.5 3 3.25 3 4.16667V15.8333C3 16.75 3.75 17.5 4.66667 17.5H10.5"
                fill={fill}
            />
            <path
                d="M7.25 5.16666V8.83332"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.41663 7H9.08329"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.49996 14.3333L5.91663 11.75"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.49996 11.75L5.91663 14.3333"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.9166 7H15.5833"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.9166 11.9167H15.5833"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.9166 14.1667H15.5833"
                stroke={stroke}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Calculator;
